import type { IconData } from '@stacksjs/iconify-core'

export const contentVideoOff: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m0 1l1-1l2 2h9v3a5 5 0 0 1 4-2v10a4.98 4.98 0 0 1-2.999-.999L16 15l-1 1zm0 2v11h11z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentVideoOff
